import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, useNavigate } from "react-router-dom";

type ThisProps = {
  aktuelleseite: string,
}

const MenuComponent: React.FC<ThisProps> = (props) => {
  const navigate = useNavigate();
  
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <nav className="navbar navbar-expand-md navbar-light bg-light shadow-sm" style={{width: "100%"}}>

      <Link className="navbar-brand" to="/">
        <img width="30%" src="/img/concordia_neermoor_logo_3d_klein.png" />
      </Link>
      <button
        className="navbar-toggler"
        type="button"
        onClick={toggleMenu}
        aria-controls="navbarNav"
        aria-expanded={isOpen}
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarNav">
        <ul className="navbar-nav ml-auto">
          <li className="nav-item">
            <Link className="nav-link" to="/">
              Startseite
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/anmeldung">
              Anmeldung
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/teilnehmerliste">
              Teilnehmer
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/rangliste">
              Rangliste
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default MenuComponent;